import React from 'react'
import { observer } from 'mobx-react'

export default observer(({ children, field }) => (
    <div>
        {children}
        <small className="text--danger">{field.error}</small>
    </div>
))